import React from 'react';
import { IconWithBackground } from '../ui/icon-with-background';
import { FeatherCalendar } from '../ui/icons';
import './LeaveBalanceCard.css';

const LeaveBalanceCard = ({ balance, year }) => {
  const usedLeaves = balance?.used_leaves || 0;
  const totalLeaves = balance?.total_leaves || 18;
  const remainingLeaves = Math.max(0, balance?.remaining_leaves ?? (totalLeaves - usedLeaves));
  const excessLopDays = balance?.excess_lop_days ?? Math.max(0, usedLeaves - totalLeaves);
  const quotaUsed = Math.min(usedLeaves, totalLeaves);

  const getRemainingVariant = () => {
    if (remainingLeaves >= 10) return 'success';
    if (remainingLeaves >= 5) return 'warning';
    return 'error';
  };

  return (
    <div className="leave-balance-card">
      <div className="leave-balance-header">
        <IconWithBackground 
          icon={<FeatherCalendar />} 
          variant="brand"
        />
        <div className="leave-balance-title">
          <h3>Leave Balance</h3>
          <span className="leave-balance-year">{year}</span>
        </div>
      </div>
      <div className="leave-balance-stats">
        <div className="leave-balance-stat">
          <span className="stat-label">Total Leaves</span>
          <span className="stat-value">{totalLeaves}</span>
        </div>
        <div className="leave-balance-stat">
          <span className="stat-label">Used</span>
          <span className="stat-value used">{usedLeaves}</span>
        </div>
        <div className="leave-balance-stat">
          <span className="stat-label">Remaining</span>
          <span className={`stat-value remaining ${getRemainingVariant()}`}>
            {remainingLeaves}
          </span>
        </div>
      </div>
      <div className="leave-balance-progress">
        <div 
          className="leave-balance-progress-bar"
          style={{ width: `${totalLeaves > 0 ? (quotaUsed / totalLeaves) * 100 : 0}%` }}
        />
      </div>
      {excessLopDays > 0 && (
        <p className="leave-balance-excess">
          {excessLopDays} day{excessLopDays === 1 ? '' : 's'} beyond quota will be treated as LOP
        </p>
      )}
    </div>
  );
};

export default LeaveBalanceCard;

